import { render, staticRenderFns } from "./Alipaybinding.vue?vue&type=template&id=ef636d3a&scoped=true&"
import script from "./Alipaybinding.vue?vue&type=script&lang=js&"
export * from "./Alipaybinding.vue?vue&type=script&lang=js&"
import style0 from "./Alipaybinding.vue?vue&type=style&index=0&id=ef636d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef636d3a",
  null
  
)

component.options.__file = "Alipaybinding.vue"
export default component.exports